var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-widget"},[_c('iframe',{staticClass:"wp-mertios",attrs:{"src":"https://wp.meritios.com/"}}),(_vm.show_cookie_law)?_c('cookieLaw',{on:{"decline":function($event){return _vm.cookieAccepted('declined')},"allow":function($event){return _vm.cookieAccepted('allowed')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }